import React, { Component } from "react";
import moment from 'moment';
import ReactTable, { Filter } from "react-table";
import { Modal } from "reactstrap";
import { useForm } from "react-hook-form";
import VideoCatalogueModule from "..";
import { Link } from "react-router-dom";
import { resolveAssetUrl } from "../../../shared/utils";

const TableFilter = (propertyKey: string) => (filter: Filter, row: any, column: any): any => {
  if (row._original[propertyKey]) {
    try {
      return row._original[propertyKey].trim().toLowerCase().indexOf(filter.value.trim().toLowerCase()) > -1;
    } catch (e) {
      console.error(e);
    }
  }
  return false;
}

const defaultImage = require("./../assets/images/default-image.png");

export default class TableView extends Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      isNewModalOpen: false,
    };
    this.toggleAddModal = this.toggleAddModal.bind(this);
    this.handleAddClick = this.handleAddClick.bind(this);
    this.handleFetch = this.handleFetch.bind(this);
  }

  toggleAddModal() {
    this.setState({
      isNewModalOpen: !this.state.isNewModalOpen,
    });
  }

  handleAddClick = (data: any) => {
    const module: VideoCatalogueModule = this.props.module;
    const history = this.props.history;
    module.services
      .create(data.title)
      .then((response: any) => {
        this.toggleAddModal();
        history.push(`/admin/current-affairs/editor/${response._id}`);
      })
      .catch((e) => {
        this.props.module.showError(
          "Item cannot be added",
          e.message ? e.message : "Network error",
          true
        );
      });
  };

  handleFetch() {
    const module: VideoCatalogueModule = this.props.module;
    module.services
      .getAll()
      .then((response: any) => {
        module.controller.setListingData(response);
      })
      .catch((e) => {
        this.props.module.showError(
          "Fetching course failed",
          e.message ? e.message : "Network error",
          true
        );
      });
  }

  componentDidMount() {
    this.handleFetch();
  }

  render() {
    const data = this.props.data;
    if (!data) {
      return <div>Loading</div>;
    }
    return (
      <>
        <div className="col-12">
          <div className="sticky-button-wrapper py-4 pr-3 d-flex justify-content-between align-items-center">
            <h4>Current Affair Manager</h4>
            <button
              onClick={this.toggleAddModal}
              className="add-lecture-button-wrapper px-5 py-3"
            >
              New Post
            </button>
          </div>
          <div className="pt-3">
            <ReactTable
              minRows={3}
              defaultPageSize={100}
              data={data}
              columns={[
                {
                  Header: "Title",
                  accessor: "titleDisplay",
                  filterable: true,
                  filterMethod: TableFilter('titleDisplay'),
                  Cell: (row) => {
                    const data = row.original;
                    return (
                      <div className="d-flex">
                        <img
                          width={124}
                          src={
                            data.bannerImageId
                              ? resolveAssetUrl(data.bannerImageId, "public")
                              : defaultImage
                          }
                          alt="Video thumbnail"
                        />
                        <Link
                          className="text-primary ml-3"
                          rel="noopener noreferrer"
                          to={`/admin/current-affairs/editor/${row.original._id}`}
                        >
                          {row.value}
                        </Link>
                      </div>
                    );
                  },
                },
                {
                  Header: "Status",
                  accessor: "isPublished",
                  width: 100,
                  Cell: (row) => {
                    return (
                      <span
                        className={`${row.value === true
                            ? "text-success"
                            : "text-danger font-weight-bold"
                          }`}
                      >
                        {row.value === true ? "Published" : "Unpublished"}
                      </span>
                    );
                  },
                },
                {
                  Header: "PDF Uploaded",
                  accessor: "hasPDFUploaded",
                  filterable: true,
                  width: 200,
                  filterMethod: TableFilter('titleDisplay'),
                },
              ]}
            />
          </div>
        </div>
        {/* @ts-ignore */}

        <Modal
          autoFocus={true}
          centered={true}
          toggle={this.toggleAddModal}
          isOpen={this.state.isNewModalOpen}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">New Item</h5>
              <button
                type="button"
                onClick={this.toggleAddModal}
                className="close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <NewItemForm
                handleAddClick={this.handleAddClick}
                toggleAddModal={this.toggleAddModal}
              />
            </div>
          </div>
        </Modal>
      </>
    );
  }
}

function NewItemForm(props: any) {
  const { register, handleSubmit, errors } = useForm({
    defaultValues: {
      title: moment().format('YYYY-MM-DD')
    }
  });
  const toggleAddModal = props.toggleAddModal;
  const handleAddClick = props.handleAddClick;

  return (
    <form onSubmit={handleSubmit(handleAddClick)}>
      <input
        autoFocus={true}
        autoComplete="off"
        type="date"
        name="title"
        ref={register({ required: true })}
        className="form-control"
        placeholder="Enter Title"
      />
      {errors.title && (
        <small className="text-danger" id="otp-error">
          Please provide a title
        </small>
      )}
      <div className="modal-footer">
        <button
          type="button"
          onClick={toggleAddModal}
          className="btn btn-default"
        >
          Cancel
        </button>
        <button type="submit" className="btn btn-primary">
          Create Post
        </button>
      </div>
    </form>
  );
}
